import { drawDrawingComposite } from './drawingShadow';
import type { Asset, Draft, Surface } from '../shared/types';
import { footprint } from '../shared/paint';

export function wallPatch(surface: Surface, _point?: { x: number; y: number }): Draft {
  return { surfaceId: surface.id, assetId: 'wall-draft', width: surface.width, height: surface.height, x: 0, y: 0 };
}
export function wallDrawingResolution(surface: Surface) {
  const scale = Math.min(4, 2048 / Math.max(surface.width, surface.height));
  return { width: Math.round(surface.width * scale), height: Math.round(surface.height * scale) };
}

// This editing estimate is replaced by the server-derived mask after finishing.
export function drawingEstimate(canvas: HTMLCanvasElement, surface: Surface, draft: Draft, shadow?: HTMLCanvasElement): number {
  const sample = document.createElement('canvas');
  const scale = 256 / Math.max(canvas.width, canvas.height);
  sample.width = Math.max(1, Math.round(canvas.width * scale));
  sample.height = Math.max(1, Math.round(canvas.height * scale));
  const context = sample.getContext('2d');
  if (!context) return 0;
  drawDrawingComposite(context, canvas, shadow, sample.width, sample.height);
  const pixels = context.getImageData(0, 0, sample.width, sample.height).data;
  const alpha = Array.from({ length: sample.width * sample.height }, (_, index) => pixels[index * 4 + 3]);
  const asset: Asset = { id: draft.assetId, kind: 'drawing', label: 'Wall drawing', url: '',
    width: canvas.width, height: canvas.height, mask: { width: sample.width, height: sample.height, alpha } };
  return footprint(surface, asset, draft).cost;
}
